import { gql } from '@apollo/client';

const GET_MERGED_PRACTICE_AREAS_WITH_PRACTICES = gql`
  query GetPracticeAreasWithPractices {
    practiceAreasMerged {
      MergedPracticeAreaIds
      InternalId
      Name
      Acronym
      Practices {
        NumberWithinLevel
        PracticeGroup {
          Level
        }
      }
    }
  }
`;

export default GET_MERGED_PRACTICE_AREAS_WITH_PRACTICES;
